module.exports = __webpack_public_path__ + "static/media/20.d00731fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/20.jpg
// module id = 389
// module chunks = 0